
import { useParams } from "react-router-dom";

export const RedirectToResidents = () => {
    let { serial_number } = useParams();
    window.location.href = `${process.env.REACT_APP_RESIDENTS_URL}/${serial_number}/`;
}